// extracted by mini-css-extract-plugin
export var option = "_dn-0";
export var optionCard = "_dn-f";
export var optionContent = "_dn-g";
export var optionIcon = "_dn-i";
export var optionIconBox = "_dn-h";
export var optionLabel = "_dn-j";
export var optionPill = "_dn-m";
export var optionPillBadge = "_dn-p";
export var optionPillIcon = "_dn-n";
export var optionPillLabel = "_dn-o";
export var optionRadio = "_dn-k";
export var optionRadioInner = "_dn-l";
export var optionReveal = "_dn-2";
export var optionRevealDelay0 = "_dn-3";
export var optionRevealDelay1 = "_dn-4";
export var optionRevealDelay10 = "_dn-d";
export var optionRevealDelay11 = "_dn-e";
export var optionRevealDelay2 = "_dn-5";
export var optionRevealDelay3 = "_dn-6";
export var optionRevealDelay4 = "_dn-7";
export var optionRevealDelay5 = "_dn-8";
export var optionRevealDelay6 = "_dn-9";
export var optionRevealDelay7 = "_dn-a";
export var optionRevealDelay8 = "_dn-b";
export var optionRevealDelay9 = "_dn-c";
export var optionSelected = "_dn-1";